var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "paper-plane",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.981,
    height: 19.148,
    viewBox: "0 0 19.981 19.148",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_326",
    "data-name": "Trac\\xE9 326",
    d: "M8.75,17.612v3.861a.624.624,0,0,0,1.127.37l2.259-3.074Z",
    transform: "translate(-1.465 -2.949)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_327",
    "data-name": "Trac\\xE9 327",
    d: "M19.719.116a.625.625,0,0,0-.651-.045L.336,9.853A.625.625,0,0,0,.422,11l5.208,1.78L16.72,3.3,8.138,13.634l8.727,2.983a.639.639,0,0,0,.2.033.624.624,0,0,0,.618-.532L19.974.717a.625.625,0,0,0-.256-.6Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.e4b4365e31d552d17d6fc5a3be57c141.svg";
export { ForwardRef as ReactComponent };